// extracted by mini-css-extract-plugin
export default {"seller":"styles_seller__NDUbN","address":"styles_address__MkDvd"};